const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://localhost:5001/",
        media_url: "https://vinhphucip-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "vinhphucip",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/vinhphucip/wms/",
  },
  production: {
      api: "https://vinhphucip-api.cgis.asia/",
      media_url: "https://vinhphucip-api.cgis.asia/",
      domainAdminSide: "https://admin.vinhphucip.cgis.asia",
      domainUserSide: "https://vinhphucip.cgis.asia",
      domainName: "vinhphucip.cgis.asia",
      workSpace: "vinhphucip",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/vinhphucip/wms/",
  },
};

module.exports = apiEnvironment[env];
